import {
  GET_CITY,

  GET_COMPANIES,
  GET_COMPANY,
  GET_POSITIONS,
  GET_POSITION,
  CLEAR_CITY,
  CLEAR_POSITION,
  CLEAR_COMPANY,
  CLEAR_ALL,
  GET_CITIES
} from './constants';

export function getCitiesAction(city: string) { 
  return {
    type: GET_CITIES,
    city
  }
}

export function getCompaniesAction(employer: string) {
  return {
    type: GET_COMPANIES,
    employer
  }
}

export function getPositionsAction(title: string) { 
  return {
    type: GET_POSITIONS,
    title
  }
}


export function getCityBySlug(city: string) { 
  return {
    type: GET_CITY,
    city
  }
}

export function getPositionBySlug(position: string) { 
  return {
    type: GET_POSITION,
    position
  }
}

export function getCompanyBySlug(slug: string) { 
  return {
    type: GET_COMPANY,
    slug
  }
}

export function clearCityAction() { 
  return {
    type: CLEAR_CITY,
  }
}

export function clearPositionAction() { 
  return {
    type: CLEAR_POSITION,
  }
}

export function clearCompanyAction() { 
  return {
    type: CLEAR_COMPANY,
  }
}


export function clearAll() { 
  return {
    type: CLEAR_ALL,
  }
}